import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.5 21H11V19H18.7227L17.5 21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 21H6.5L5.27734 19H9V21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 17H9V15H17V17Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.9443 17H19V15H21.167L19.9443 17Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 17H4.05566L2.83301 15H7V17Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 12L22.3887 13H14V11H22.3887L23 12Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 13H1.61133L1 12L1.61133 11H12V13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.167 9H2.83301L4.05566 7H19.9443L21.167 9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.7227 5H16V3H17.5L18.7227 5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14 5H5.27734L6.5 3H14V5Z"}}]};

const LogoTencentcode = Vue.extend<IconProps>({
  name: 'LogoTencentcodeIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-tencentcode',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoTencentcode;
